import AuthService from '../../utilities/services/auth.service'

import { AccessPassHoldersReportWrapper } from '../../components/AccessPassHoldersReportWrapper'

export default function AccessPassHoldersReportPage() {
  const organization = AuthService.getOrg()[0]

  return <AccessPassHoldersReportWrapper organization={organization} />
}
